export enum PRICING_VERSIONS {
  V2016_01 = '2016-01',
  V2019_08 = '2019-08',
  V2020_09 = '2020-09',
  V2024_08 = '2024-08',
}
